import { Box, Typography } from "@mui/material";

const designVariants = {
  primary: {
    boxStyles: {
      backgroundColor: "var(--mui-palette-background-paper)",
      borderRadius: "999px",
      padding: "0.875rem",
      gap: "0.25rem",
      flex: 1,
    },
    valueStyles: {
      fontSize: "1.25rem",
      fontWeight: "800",
    },
    titleStyles: {
      fontSize: "1rem",
      fontWeight: "600",
    },
  },
  secondary: {
    boxStyles: {
      backgroundColor: "var(--background-card-secondary)",
      borderRadius: "999px",
      padding: "0.5rem 0.875rem",
      gap: "0.25rem",
      flex: 1,
    },
    valueStyles: {
      fontSize: "1.125rem",
      fontWeight: "800",
    },
    titleStyles: {
      fontSize: "0.875rem",
      fontWeight: "600",
    },
  },
};

export const DashboardOverviewCard = ({ value, title, variant = "primary" }) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        ...designVariants[variant].boxStyles,
        "@media print": {
          padding: "0.25rem",
          margin: 0,
          gap: "0.25rem",
          borderRadius: "0.875rem",
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            margin: 0,
            padding: 0,
          },
        },
      }}
      className="dashboard-overview-card"
    >
      <Typography
        sx={{
          "&.MuiTypography-root": {
            marginBottom: "0 !important",
            ...designVariants[variant].valueStyles,
            "@media print": {
              fontSize: "0.875rem",
              margin: 0,
              padding: 0,
            },
          },
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          ...designVariants[variant].titleStyles,
          "@media print": {
            fontSize: "0.75rem",
            margin: 0,
            padding: 0,
          },
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
